var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_kng_upload_tit_choose5" /** 选择系统封面 */),
        size: "960px",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-system-image" },
        _vm._l(_vm.list, function (item) {
          return _c("img", {
            key: item,
            class:
              item === _vm.url
                ? "border-primary-6 yxtbiz-system-image--selected"
                : "",
            attrs: { src: item, alt: "" },
            on: {
              click: function ($event) {
                return _vm.select(item)
              },
            },
          })
        }),
        0
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */)))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }